import { FC } from 'react';
import Footer from 'src/components/common/Footer';
import Header from 'src/components/common/Header';

const MainLayout: FC<any> = ({ children }) => {
  return (
    <>
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
    </>
  );
};

export default MainLayout;
